import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { BackEndService } from 'src/app/services/backEnd.service';
import { FirebaseOtpService } from 'src/app/services/firebase-otp.service';
import { TranslateService } from 'src/app/services/translate.service';
import { VaniService } from 'src/app/services/vani.service';
import { LoaderService } from 'src/app/util/loader.service';
import { ToastService } from 'src/app/util/toast.service';

@Component({
  selector: 'app-slide1',
  templateUrl: './slide1.component.html',
  styleUrls: ['./slide1.component.scss'],
})
export class Slide1Component implements OnInit {

  @Input() invitee: any;
  languageList: any[] = [
    { value: "en", name: "English" },
    { value: "hi", name: "Hindi" },
  ]
  selectedLang = { value: "en", name: "English" };
  currentStep: 'phone' | 'otp' = 'phone';
  phoneNumber: string = '';
  countryCode: string = '';
  name: string = '';

  constructor(
    public auth: AuthService, public backEnd: BackEndService,
    public translateService: TranslateService, private vani: VaniService,
    private firebaseOtpService: FirebaseOtpService, private toast: ToastService,
    private loader: LoaderService
  ) { }

  async ngOnInit() {
    console.log("Session checking ", this.backEnd.session);
    setTimeout(() => {
      this.vani.read("Verify yourself with Google authentication that you are using this app.");
    }, 500);
  }

  async googleLogin() {
    this.loader.show();
    try {
      const data: any = await this.auth.googleLogin();
      this.loader.hide();
      if (data) {
        console.log("Google login successful, session will be handled by session$ subscription");
      }
    } catch (error) {
      this.loader.hide();
      console.error("Google login error", error);
    }
  }

  changeLang(value) {
    this.translateService.setLanguage(value);
  }

  onOtpSent(data: any) {
    this.phoneNumber = data.fullPhoneNumber;
    this.countryCode = data.countryCode;
    this.name = data.name;
    console.log('OTP sent for:', this.phoneNumber, 'Country:', this.countryCode, 'Name:', this.name);
    this.currentStep = 'otp';
  }

  async onVerificationComplete(result: any) {
    if (result) {
      this.toast.success(this.translateService.translate('Phone number verified successfully!'));
      console.log('OTP login successful, session will be handled by session$ subscription');
      // No need to emit events — parent page subscribes to session$ directly
    } else {
      console.warn('Backend session missing despite OTP verification.');
      this.toast.error(this.translateService.translate("Authentication failed. Please try again."));
    }
  }

  async onResendOTP() {
    try {
      await this.firebaseOtpService.sendOTP(this.phoneNumber, this.countryCode);
      this.toast.success(this.translateService.translate('OTP resent successfully!'));
    } catch (error: any) {
      console.error('Error resending OTP:', error);
      this.toast.error(this.translateService.translate('Failed to resend OTP') + ': ' + (error.message || ''));
    }
  }

  goBackToPhoneInput() {
    this.currentStep = 'phone';
    this.firebaseOtpService.clearRecaptcha();
  }
}

